import { createStyles, makeStyles } from '@material-ui/core';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import React from 'react';

const themeSettings = { name: 'LoginPageLogo' };

export type LoginPageLogoProps = {
  className?: string;
};

export type LoginPageLogoClassNameKey = 'root';

const useStyles = makeStyles(() =>
  createStyles<LoginPageLogoClassNameKey, {}>({
    root: {
      maxWidth: '310px',
      maxHeight: '76px',
      width: '100%',
      height: '100%',
    },
  }),
);

const LoginPageLogoEurovia = React.forwardRef<HTMLOrSVGImageElement, LoginPageLogoProps>(() => {
  const classes = useStyles();
  return (
    // <svg
    //   id='Vrstva_1'
    //   data-name='Vrstva 1'
    //   xmlns='http://www.w3.org/2000/svg'
    //   viewBox='0 0 600.65 146.99'
    //   className={classes.root}
    // >
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='543.88'
      height='140.707'
      viewBox='0 0 407.91 105.53'
      id='Vrstva_1'
      data-name='Vrstva 1'
      className={classes.root}
    >
      <defs>
        <clipPath id='a'>
          <path d='M337 35h70.91v70.531H337zm0 0' />
        </clipPath>
        <clipPath id='b'>
          <path d='M283 88h17v17.531h-17zm0 0' />
        </clipPath>
        <clipPath id='c'>
          <path d='M144 88h16v17.531h-16zm0 0' />
        </clipPath>
        <clipPath id='d'>
          <path d='M191 88h15v17.531h-15zm0 0' />
        </clipPath>
        <clipPath id='e'>
          <path d='M264 88h16v17.531h-16zm0 0' />
        </clipPath>
        <clipPath id='f'>
          <path d='M124 88h17v17.531h-17zm0 0' />
        </clipPath>
        <clipPath id='g'>
          <path d='M209 88h14v17.531h-14zm0 0' />
        </clipPath>
        <clipPath id='h'>
          <path d='M163 88h12v17.531h-12zm0 0' />
        </clipPath>
        <clipPath id='i'>
          <path d='M110 88h13v17.531h-13zm0 0' />
        </clipPath>
        <clipPath id='j'>
          <path d='M226 88h14v17.531h-14zm0 0' />
        </clipPath>
        <clipPath id='k'>
          <path d='M176 88h13v17.531h-13zm0 0' />
        </clipPath>
        <clipPath id='l'>
          <path d='M241 88h12v17.531h-12zm0 0' />
        </clipPath>
        <clipPath id='m'>
          <path d='M256 88h5v17.531h-5zm0 0' />
        </clipPath>
      </defs>
      <g clipPath='url(#a)'>
        <path
          d='M353.332 105.23c-3.254 0-6.504.012-9.758-.003-3.543-.016-5.695-2.11-5.71-5.649-.036-6.508-.032-13.012-.005-19.52.016-3.624 2.149-5.69 5.786-5.695 4.726-.004 9.453.028 14.18-.004 7.605-.058 13.304-4.941 14.46-12.324.328-2.105-.191-4.14-.46-6.2-1.212-9.323 4.816-17.937 14.054-20.062 10.367-2.382 20.508 4.606 21.871 15.07 1.602 12.274-9.086 22.56-21.293 20.348-5.691-1.03-10.488.25-14.316 4.641-2.317 2.66-3.329 5.84-3.336 9.348-.008 4.812.004 9.629-.004 14.441-.008 3.473-2.102 5.582-5.582 5.606-3.293.02-6.59.003-9.887.003'
          fill='#e81e33'
        />
      </g>
      <path
        d='M316.457 67.746c-4.77 0-9.543-.02-14.312.024-.887.007-1.172-.2-1.168-1.133a3534.3 3534.3 0 0 0-.004-28.758c-.004-1.031.347-1.188 1.261-1.18 5.856.04 11.711.024 17.567.02 7.637-.008 14.277-4.477 17.18-11.559.582-1.418.886-2.887.878-4.43-.02-4.859-.011-9.714-.007-14.574.007-4.125 2.03-6.152 6.148-6.152 6.332 0 12.664-.004 18.996 0 3.723.004 5.805 2.082 5.805 5.789.004 6.465.008 12.926 0 19.39-.004 3.637-2.098 5.739-5.723 5.743-4.465.008-8.933.07-13.398-.012-7.485-.137-12.336 3.867-15.782 9.992-1.402 2.489-1.859 5.293-1.859 8.157.012 5.812-.023 11.624.031 17.437.008 1.047-.3 1.281-1.3 1.27-4.77-.051-9.54-.024-14.313-.024'
        fill='#e81e33'
      />
      <path
        d='M180.508 55.582c0-5.117.027-10.234-.028-15.352-.007-.933.29-1.265 1.168-1.437 12.88-2.54 25.883-3.074 38.961-2.45 6.848.325 13.641 1.102 20.38 2.41.988.192 1.347.528 1.32 1.571-.075 2.95-.067 5.899-.004 8.844.023.984-.176 1.242-1.2 1.07-8.73-1.492-17.535-2.195-26.386-2.441-6.739-.188-13.418.355-20.094 1.172-.637.078-.895.293-.895.965.016 3.73-.003 7.457-.03 11.187-.005.715.198 1.008 1.007 1.125 13.281 1.926 26.543 1.336 39.8-.226 2.321-.274 4.634-.633 6.942-1.008.633-.102.848 0 .844.668-.023 3.254-.031 6.504.004 9.758.008.753-.442.816-.969.925-3.992.825-8.023 1.399-12.074 1.82a172.161 172.161 0 0 1-29.219.547c-6.144-.402-12.25-1.109-18.297-2.308-.945-.188-1.265-.496-1.258-1.488.055-5.118.028-10.235.028-15.352m-62.742-1.086c0 6.2-.036 12.313.027 18.426.012 1.183-.281 1.535-1.492 1.504-3.512-.086-7.024-.055-10.54-.012-.863.012-1.198-.168-1.195-1.129a4855.58 4855.58 0 0 0-.007-35.394c-.004-1.473.757-.98 1.453-.813 9.367 2.27 18.172 5.953 26.582 10.629 6.484 3.602 12.82 7.438 18.898 11.691.238.168.434.434.934.391v-1.215c0-6.808.023-13.62-.024-20.43-.007-1.078.164-1.496 1.387-1.464 3.598.097 7.2.058 10.8.015.798-.008 1.032.22 1.032 1.024-.023 11.883-.023 23.77-.004 35.656.004.781-.21 1.047-1.023 1.04-3.774-.04-7.547-.044-11.32 0-.79.01-1.29-.388-1.844-.802-10.047-7.48-20.664-13.992-32.305-18.726a29.21 29.21 0 0 0-.965-.387c-.074-.023-.168-.004-.394-.004m-50.922-9.031c-.192.144-.48.332-.735.558a69654.697 69654.697 0 0 0-25.273 22.672c-2.258 2.028-4.535 4.04-6.77 6.09-.511.469-.828.512-1.379.02-10.73-9.66-21.48-19.301-32.242-28.926-.543-.484-.629-.75-.035-1.277a497.915 497.915 0 0 0 8.75-7.973c.688-.645.985-.254 1.445.187 7.262 6.961 14.551 13.891 21.774 20.891.86.832 1.25.68 2.008-.05 7.207-6.95 14.465-13.852 21.668-20.81.71-.69 1.074-.648 1.754-.007 2.746 2.586 5.55 5.11 8.328 7.664.246.223.578.383.707.96M270.523 55.61c0 5.85-.02 11.699.016 17.55.008.934-.18 1.278-1.2 1.262a374.176 374.176 0 0 0-11.312-.004c-.925.012-1.152-.277-1.152-1.176a6315.88 6315.88 0 0 0-.004-35.363c-.004-1.04.356-1.195 1.27-1.184 3.726.047 7.457.055 11.183-.004.992-.02 1.227.278 1.219 1.235-.043 5.894-.02 11.789-.02 17.683M75.918 55.46c0-5.808.031-11.62-.027-17.429-.012-1.113.32-1.36 1.379-1.343 3.683.066 7.37.054 11.058.007.871-.011 1.184.164 1.18 1.121a6727.263 6727.263 0 0 0 0 35.516c0 .875-.262 1.09-1.098 1.082-3.773-.039-7.547-.059-11.32.008-1.031.02-1.195-.344-1.192-1.266.04-5.898.02-11.797.02-17.695'
        fill='#0d528f'
      />
      <g clipPath='url(#b)'>
        <path
          d='M287.04 92.941c0 3.801-.048 7.387.026 10.97.024 1.093-.28 1.495-1.355 1.327-.383-.058-.781-.031-1.172-.004-.543.04-.773-.152-.773-.73.015-5.113.011-10.227.015-15.34 0-.246-.027-.492.297-.633 1.043-.453 3.488.164 4.164 1.082 2.485 3.387 4.969 6.774 7.465 10.18.414-.215.195-.602.2-.895.007-3.074.027-6.152-.032-9.226-.016-.879.172-1.207 1.125-1.184 2.203.047 2.203-.008 2.203 2.164 0 4.461-.031 8.926.027 13.391.012 1-.304 1.164-1.238 1.23-1.472.11-2.34-.437-3.172-1.632-2.468-3.551-5.082-7.008-7.78-10.7'
          fill='#0d528f'
        />
      </g>
      <g clipPath='url(#c)'>
        <path
          d='M156.3 100.102c0-3.68.048-7.02-.03-10.352-.024-1.07.332-1.398 1.312-1.238a.95.95 0 0 0 .258 0c1.308-.227 1.738.23 1.71 1.629-.1 4.636-.07 9.277-.01 13.914.01 1.007-.31 1.152-1.235 1.226-1.438.117-2.262-.433-3.067-1.582-2.472-3.531-5.07-6.976-7.828-10.742v3.766c0 2.297.02 4.593-.015 6.89-.004.528.32 1.383-.262 1.528-.895.218-1.887.082-2.832.011-.301-.023-.184-.433-.184-.675-.008-5.07-.008-10.145-.004-15.215 0-.25-.07-.535.196-.711.683-.457 3.632.148 4.148.847 2.55 3.485 5.106 6.97 7.844 10.704'
          fill='#0d528f'
        />
      </g>
      <g clipPath='url(#d)'>
        <path
          d='M195.633 93.605v1.434c0 2.102.086 2.18 2.191 1.922 2.223-.27 3.383-1.227 3.563-2.941.277-2.641-1-3.95-3.852-3.946-1.82.004-1.898.082-1.902 1.84v1.691zm4.078 4.258c2.098 2.512 4.043 4.832 6.164 7.371-1.453 0-2.684-.007-3.914.004-.594.008-.785-.484-1.066-.843-1.68-2.133-3.34-4.278-5.262-6.743 0 2.446-.031 4.5.015 6.551.02.77-.144 1.05-.984 1.059-2.887.031-2.887.07-2.887-2.79 0-4.034.036-8.07-.023-12.1-.012-.903.242-1.34 1.121-1.544 2.875-.676 5.75-.863 8.617-.047 1.61.461 2.93 1.34 3.492 3.024.899 2.66-.636 5.058-3.672 5.765-.457.106-.925.172-1.601.293'
          fill='#0d528f'
        />
      </g>
      <g clipPath='url(#e)'>
        <path
          d='M275.89 96.773c.02-1.437-.062-2.859-.636-4.199-.602-1.386-1.613-2.222-3.184-2.226-1.562-.008-2.691.75-3.215 2.172-1.03 2.808-1.05 5.68-.027 8.496.524 1.441 1.668 2.125 3.235 2.12 1.578-.003 2.613-.753 3.214-2.163.575-1.344.63-2.77.614-4.2zm-3.878 8.7c-5.352-.012-8.457-3.91-7.782-9.782.645-5.66 4.47-8.414 10.012-7.195 2.715.598 4.387 2.328 5.164 4.938.594 1.984.63 4.027.211 6.046-.816 3.965-3.433 5.997-7.605 5.993'
          fill='#0d528f'
        />
      </g>
      <g clipPath='url(#f)'>
        <path
          d='M136.29 96.91c.03-1.437-.099-2.855-.622-4.203-.566-1.46-1.594-2.336-3.223-2.363-1.52-.024-2.695.719-3.27 2.289-.991 2.73-.991 5.52-.034 8.254.562 1.613 1.722 2.281 3.41 2.242 1.558-.04 2.61-.805 3.183-2.39.45-1.235.578-2.524.555-3.829zm-11.692-.078c0-.387-.024-.781.004-1.168.418-6.11 6.43-9.41 11.855-6.504 1.84.985 2.879 2.586 3.395 4.547.46 1.738.523 3.516.214 5.285-.808 4.598-3.609 6.711-8.492 6.453-4.02-.21-6.672-2.988-6.969-7.312-.03-.434-.003-.867-.007-1.301'
          fill='#0d528f'
        />
      </g>
      <g clipPath='url(#g)'>
        <path
          d='M209.172 95.012c0-1.82.05-3.64-.02-5.457-.035-.887.278-1.067 1.098-1.063 2.828.012 2.828-.02 2.828 2.824 0 2.903-.008 5.809.004 8.711.008 2.02 1.129 3.075 3.2 3.051 1.964-.023 3.042-1.09 3.05-3.062.012-3.426.035-6.848-.016-10.274-.015-.914.141-1.285 1.18-1.258 2.477.063 2.477.004 2.477 2.536v8.324c0 3.469-1.45 5.312-4.86 5.965-1.937.37-3.898.32-5.746-.493-2.035-.898-3.238-2.39-3.199-4.73.027-1.691.004-3.383.004-5.074'
          fill='#0d528f'
        />
      </g>
      <g clipPath='url(#h)'>
        <path
          d='M167.762 105.488c-1.309-.015-2.602-.148-3.84-.59-.418-.148-1.09-.253-.598-.918.375-.511.055-1.832 1.363-1.355a8.092 8.092 0 0 0 3.32.46c1.47-.1 2.485-.858 2.727-1.991.258-1.227-.261-2.078-1.797-2.778-.98-.453-2.03-.761-2.988-1.254-1.59-.824-2.707-2.027-2.648-3.976.062-2.004 1.156-3.328 2.894-4.121 2.383-1.078 4.813-.863 7.23-.078.466.152.852.41.427.922-.336.406-.043 1.488-1.172 1.093-1.192-.422-2.407-.699-3.692-.379-1.035.262-1.715.856-1.886 1.903-.18 1.082.367 1.86 1.304 2.312.973.465 2.004.813 2.992 1.246 2.747 1.2 3.778 2.75 3.438 5.137-.313 2.192-2.453 3.95-5.258 4.277-.601.07-1.21.063-1.816.09'
          fill='#0d528f'
        />
      </g>
      <g clipPath='url(#i)'>
        <path
          d='M118.957 105.469c-5.98.05-9.547-4.672-8.32-10.633 1.36-6.582 7.203-7.402 11.285-6.027.375.125 1.101.203.644.925-.308.485-.136 1.438-1.308 1.125-3.813-1.007-6 .485-6.649 4.371a9.872 9.872 0 0 0 .157 4.004c.754 3.09 3.191 4.563 6.207 3.579 1.367-.446 1.261.578 1.586 1.19.496.934-.446.852-.856 1.017-.973.39-2.02.46-2.746.449'
          fill='#0d528f'
        />
      </g>
      <g clipPath='url(#j)'>
        <path
          d='M235.406 105.469c-5.976.039-9.511-4.57-8.418-10.41 1.235-6.582 6.926-7.672 11.23-6.282.41.133 1.184.153.739.993-.316.593-.297 1.398-1.469 1.054-3.468-1.015-5.894.621-6.453 4.184-.246 1.562-.226 3.113.254 4.629.89 2.816 3.172 4.125 5.984 3.195 1.383-.457 1.403.492 1.692 1.2.418 1.011-.594.866-1.028 1.038-.933.368-1.945.418-2.53.399'
          fill='#0d528f'
        />
      </g>
      <g clipPath='url(#k)'>
        <path
          d='M180.637 97.867c0-2.074-.028-4.152.015-6.23.016-.766-.16-1.133-.996-1.035-.554.062-1.129-.024-1.687.02-.781.054-1.27-.005-1.266-1.052.008-1.015.442-1.082 1.246-1.074 3.117.04 6.235.035 9.352 0 .777-.008 1.164.106 1.129 1.031-.032.793-.157 1.114-1.059 1.11-2.871-.016-2.871.027-2.871 2.879 0 3.546-.023 7.097.02 10.648.007.824-.188 1.102-1.063 1.098-2.82-.008-2.82.031-2.82-2.719v-4.676'
          fill='#0d528f'
        />
      </g>
      <g clipPath='url(#l)'>
        <path
          d='M245.145 97.918c0-2.121-.028-4.246.015-6.367.012-.73-.203-1.02-.95-.95-.558.055-1.14-.074-1.683.028-1.375.25-1.332-.59-1.289-1.52.02-.457.207-.601.63-.597 3.468.004 6.933.015 10.398-.008.918-.008.625.625.64 1.074.012.465.23 1.102-.668 1.043-.691-.047-1.394.05-2.078-.023-.91-.098-1.172.218-1.16 1.14.05 4.07-.008 8.145.047 12.215.012.996-.215 1.332-1.27 1.305-2.632-.067-2.632-.008-2.632-2.66v-4.68'
          fill='#0d528f'
        />
      </g>
      <g clipPath='url(#m)'>
        <path
          d='M256.32 96.7c0-2.427.016-4.852-.011-7.278-.008-.625.113-.902.84-.93 3.07-.129 3.07-.156 3.07 2.957 0 4.246-.024 8.489.02 12.73.011.868-.255 1.075-1.087 1.071-2.832-.008-2.832.027-2.832-2.836V96.7'
          fill='#0d528f'
        />
      </g>
    </svg>
  );
});

LoginPageLogoEurovia.displayName = 'LoginPageLogoEurovia';

export default withThemeProps(themeSettings)(LoginPageLogoEurovia);
